import {Component, ViewChild} from '@angular/core';
import {Http} from '@angular/http';
import {AlertController, App, Events, LoadingController, MenuController, Nav, Platform} from 'ionic-angular';
import {FavoritePage} from '../pages/favorite/favorite';
import {ImprintPage} from '../pages/imprint/imprint';
import {LoginPage} from '../pages/login/login';
import {SearchPage} from '../pages/search/search';
import {SettingsPage} from '../pages/settings/settings';
import {ConfigService} from '../providers/config';
import {UserService} from '../providers/user';
import {ErrorHandling} from '../shared/error.handling';
import {AppTheme} from "../apptheme/apptheme";

@Component({
    templateUrl: 'app.html'
})

export class MyApp {
    @ViewChild(Nav) nav: Nav;
    rootPage: any = LoginPage;
    pages: Array<{ title: string, icon: string, component: any, visible: boolean }>;
    activePage: { title: string, icon: string, component: any, visible: boolean };
    logoutStatus: boolean = false;
    config: any = {};
    loader = this.loadingCtrl.create({});

    constructor(public platform: Platform,
                public app: App,
                public alertCtrl: AlertController,
                public loadingCtrl: LoadingController,
                public menuCtrl: MenuController,
                public http: Http,
                public userService: UserService,
                public errorHandling: ErrorHandling,
                public events: Events,
                public appThemes: AppTheme,
                public configService: ConfigService) {

        this.config = this.configService.getConfig();
        this.initializeApp();

        this.pages = [
            {
                title: 'Start',
                icon: 'search',
                component: SearchPage,
                visible: true
            },
            {
                title: 'Favoriten',
                icon: 'star',
                component: FavoritePage,
                visible: true
            },
            {
                title: 'Einstellungen',
                icon: 'settings',
                component: SettingsPage,
                visible: true
            },
            {
                title: 'Informationen',
                icon: 'information-circle',
                component: ImprintPage,
                visible: true
            }
        ];

        this.activePage = this.pages[0];

        this.events.subscribe('Error(403)', () => {
            this.app.getActiveNavs()[0].setRoot(LoginPage, {logoutStatus: true}, {animate: false});
        });

        // this.events.subscribe('theme:update', (a,b) => {
        //     console.log('Event - theme:update: ', a, b);
        // });
    }

    initializeApp() {

        this.platform.ready().then(() => {

            // Favoriten
            let favorites = localStorage.getItem('favorites');
            try {
                favorites = JSON.parse(favorites);

                if (Object.prototype.toString.call(favorites) !== '[object Array]') {
                    localStorage.setItem('favorites', JSON.stringify([]));
                }
            } catch (e) {
                console.error('Catch Parse failed: ', e);
                localStorage.setItem('favorites', JSON.stringify([]));
            }

            // Externe Favoriten
            let extfavorites = localStorage.getItem('extfavorites');
            try {
                extfavorites = JSON.parse(extfavorites);

                if (Object.prototype.toString.call(extfavorites) !== '[object Array]') {
                    localStorage.setItem('extfavorites', JSON.stringify([]));
                }
            } catch (e) {
                console.error('Catch Parse failed: ', e);
                localStorage.setItem('extfavorites', JSON.stringify([]));
            }

            // color theme
            let apptheme = localStorage.getItem('settings.apptheme');
            if (apptheme === null || typeof apptheme === 'undefined') {
                localStorage.setItem('settings.apptheme', '1');
                // theme klasse (default) zu body-tag hinzufügen
                document.body.classList.add(this.appThemes.themeClass[0]);
            } else {
                // theme klasse (custom) zu body-tag hinzufügen
                document.body.classList.add(this.appThemes.themeClass[apptheme]);
            }


            // Sortierung speichern
            let sortingArr: any = {
                Address: [],
                Document: [],
                Folder: [],
                Meeting: [],
                Structure: []
            }

            let sorting = localStorage.getItem('sorting');
            try {
                sorting = JSON.parse(sorting);

                if (Object.prototype.toString.call(sorting) !== '[object Object]') {
                    console.error('sorting ist kein Object.');
                    localStorage.setItem('sorting', JSON.stringify(sortingArr));
                }
            } catch (e) {
                console.error('Catch Parse failed: ', e);
                localStorage.setItem('sorting', JSON.stringify(sortingArr));
            }


            // Last Search
            let lastsearch = localStorage.getItem('lastsearch');
            try {
                lastsearch = JSON.parse(lastsearch);

                if (Object.prototype.toString.call(lastsearch) !== '[object Array]') {
                    localStorage.setItem('lastsearch', JSON.stringify([]));
                }
            } catch (e) {
                console.error('Catch Parse failed: ', e);
                localStorage.setItem('lastsearch', JSON.stringify([]));
            }

            // Set GlobalSearch
            let useglobalsearch = localStorage.getItem('useglobalsearch');
            if (!useglobalsearch) {
                localStorage.setItem('useglobalsearch', '0');
            }

            // inifiniteScroll Counter
            let offsetCounter = localStorage.getItem('settings.offsetCounter');
            if (offsetCounter === null || typeof offsetCounter === 'undefined') {
                localStorage.setItem('settings.offsetCounter', '20');
            }

            // searchHistory
            let searchHistory = localStorage.getItem('settings.searchHistory');
            if (searchHistory === null || typeof searchHistory === 'undefined') {
                localStorage.setItem('settings.searchHistory', '10');
            }

            // searchLevel1
            let searchLevel1 = localStorage.getItem('settings.searchLevel1');
            if (searchLevel1 === null || typeof searchLevel1 === 'undefined') {
                localStorage.setItem('settings.searchLevel1', '1');
            }

            // update api > v1
            let updateapi = localStorage.getItem('settings.updateapi');
            if (updateapi === null || typeof updateapi === 'undefined') {

                let appconfig = JSON.parse(localStorage.getItem('appconfig'));
                let isAPIGreaterThanV1;
                if (appconfig) {
                    isAPIGreaterThanV1 = appconfig.apiendpoint.indexOf('/api/v');
                } else {
                    isAPIGreaterThanV1 = 0;
                }
                if (isAPIGreaterThanV1 <= 0) {
                    localStorage.setItem('settings.updateapi', '0');
                } else {
                    localStorage.setItem('settings.updateapi', '1');
                }
            }

            let isPresented = false;

            this.platform.registerBackButtonAction(() => {

                if (this.menuCtrl.isOpen()) {
                    // Close side menu if open
                    this.menuCtrl.close();

                } else {

                    let activeNav = this.app.getActiveNavs();

                    if (activeNav[0].canGoBack()) {
                        //Not root page
                        activeNav.pop();
                    } else {

                        let alert = this.alertCtrl.create({
                            title: 'regisafe beenden',
                            message: 'Möchten Sie regisafe wirklich beenden?',
                            buttons: [
                                {
                                    text: 'Nein',
                                    role: 'cancel',
                                    handler: () => {
                                        isPresented = false;
                                    }
                                },
                                {
                                    text: 'Ja',
                                    handler: () => {
                                        this.platform.exitApp();
                                    }
                                }
                            ]
                        });

                        if (isPresented !== true) {
                            alert.present();
                            isPresented = true;
                        }
                    }
                }
            });
        });
    }

    openPage(page) {
        // get the current component name and check if the new component is the same and cancel it
        let view = this.nav.getActive().id;
        if (view !== page.component.name) {
            this.nav.setRoot(page.component, {}, {animate: false});
            this.activePage = page;
        }
    }

    /**
     * Check if the page is active
     * @param page
     * @returns {boolean}
     */
    isPageActive(page) {
        return page === this.activePage;
    }

    logout() {
        let alert = this.alertCtrl.create({
            title: 'Logout',
            subTitle: 'Möchten Sie sich wirklich abmelden?',
            buttons: [{
                text: 'Ja',
                handler: () => {
                    this.userService.doLogout().subscribe((response) => {
                        this.logoutStatus = true;
                        this.activePage = this.pages[0];
                        this.nav.setRoot(LoginPage, {logoutStatus: this.logoutStatus});
                        localStorage.removeItem('nodetoken');
                    }, (error) => {
                        this.errorHandling.handle(error, 'app.components - logout');
                        this.logoutStatus = true;
                        this.activePage = this.pages[0];
                        this.nav.setRoot(LoginPage, {logoutStatus: this.logoutStatus});
                        localStorage.removeItem('nodetoken');
                    });
                }
            }, {
                text: 'Nein',
                handler: () => {
                }
            }]
        });
        alert.present();
    }

    // add events menuStatus (open/close)
    menuOpen() {
        this.events.publish('menu:open', '');
        this.pages[0].visible = false;
    }

    menuClose() {
        this.events.publish('menu:close', '');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts